import { render, staticRenderFns } from "./CreateEventHeader.vue?vue&type=template&id=6ac16e04"
import script from "./CreateEventHeader.vue?vue&type=script&lang=js"
export * from "./CreateEventHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports